var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.name.startsWith('el-'))?_c('i',{class:_vm.name}):_c('svgicon',{style:(_vm.styleSvg),attrs:{"name":_vm.name,"color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }